import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Input from '../Components/Input'
import Button from '../Components/Button'
import { use } from '../Helpers.js'
import { call } from '../Methods.js'
import { ValidateInput } from '../ValidationDefaults.js'
import Variables from '../global.js'

function Login () {
  const pageTitle = 'Giriş'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}` 
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async e => {
    if(!(e.type=='click') && !(e.type=='keyup' && e.key=='Enter')){
      return false;
    }
    setLoading(true)
    let loginData = {
      email: use.getInputValueByName('email'),
      password: use.getInputValueByName('password')
    }

    const loginResponse = await call.user.login(loginData)
    if (loginResponse?.data?.token) {
      localStorage.setItem('cm_token', loginResponse.data.token)
      navigate('/', { replace: true })
    }else{
      alert('Giriş məlumatları xətalıdır.')
    }
  }

  useEffect(()=>{
    document.addEventListener('keyup',handleLogin,{a:'test'})
    return ()=>document.removeEventListener('keyup',handleLogin,{a:'test'})
  },[])

  return (
    <div className='login-page page'>
      <div className="overlay"></div>
      <div className='form-container'>
        <form id="login-form" className='form login-form'>
          <h1>Giriş məlumatlarını daxil edin</h1>
          <Input
            type='email'
            fieldName='email'
            placeholder='E-poçt ünvanı'
            label='E-poçt ünvanı'
            col={{default:12,sm:12}}
          />
          <Input
            type='password'
            fieldName='password'
            placeholder='Şifrə'
            label='Şifrə'
            col={{default:12,sm:12}}
          />
          <Button
            type='button'
            text='Daxil olun'
            style='full-width'
            onClick={handleLogin}
          />
          <div className='form-footer'>
            <img className='course-logo' src={`${Variables.api_url}/images/settings/course_logo_small.png`} />
            <img className='app-logo' src='/Images/Logos/app_logo_dark.svg' />
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
